module.exports = __webpack_public_path__ + "img/transport-2.3fef1a51.svg";